<template>
    <b-modal
        id="group-pair-index-add-student-modal"
        size="lg"
        @show="onShow"
        :title="$t('group_pair.add_student')"
        ok-only
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal">
        <b-tabs
            class="apprentice-tab"
            fill>
            <b-tab
                :title="$t('group_pair.linked_classes')"
                active>
                <design-2021-apprentice-data-table
                    :items="studentsWithLas"
                    :fields="allStudentsFields">
                    <template v-slot:cell(actions)="data">
                        <div class="actions">
                            <design-2021-group-pair-add-student-add-input-component
                                :user="data.item"
                                :key="data.item.id"
                                :group-id="groupId">
                            </design-2021-group-pair-add-student-add-input-component>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>

            <b-tab :title="$t('group_pair.amount_students')">
                <design-2021-apprentice-data-table
                    :items="allStudents"
                    :fields="allStudentsFields">
                    <template v-slot:cell(actions)="data">
                        <div class="actions">
                            <design-2021-group-pair-add-student-add-input-component
                                :user="data.item"
                                :key="data.item.id"
                                :group-id="groupId">
                            </design-2021-group-pair-add-student-add-input-component>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-group-pair-index-add-student-modal-component',
    props: ['groupId'],
    data() {
        return {
            loaded: false,
            allStudents: [],
            studentsWithLas: [],
            allStudentsFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.add'),
                },
            ],
        };
    },
    methods: {
        onShow() {
            if (this.loaded) {
                return;
            }

            ords.use('user')
                .where('type', '=', 'student')
                .with('group_pair_students')
                .orderBy('full_name')
                .get()
                .subscribe((students) => (this.allStudents = students));

            ords.use('user')
                .where('type', '=', 'student')
                .with('group_pair_students')
                .orderBy('full_name')
                .whereHas('las_student', (lasStudentCallback) => {
                    lasStudentCallback.whereHas('las_groups', (lasGroupCallback) => {
                        lasGroupCallback.whereHas('groups');
                    });
                    lasStudentCallback.orWhere((orWhereCallback) => {
                        orWhereCallback.whereHas('las_main_groups', (lasMainGroupCallback) => {
                            lasMainGroupCallback.whereHas('groups');
                        });
                    });
                })
                .get()
                .subscribe((students) => {
                    this.studentsWithLas = students;
                });

            this.loaded = true;
        },
        clearLoaded() {
            this.loaded = false;
        },
    },
};
</script>

<style scoped></style>
